<template>
    <a
        class="dashboard__list_enrolments_grid_item"
        :disabled="courseWorkspaceId !== currentWorkspaceId && user.isInpersonated()"
        @click="handleRedirectToCourse"
    >
        <div class="columns">
            <div class="column is-narrow">
                <div class="dashboard__list_enrolments_grid_item_image">
                    <template v-if="courseThumbnailUrl">
                        <component-image
                            :url="courseThumbnailUrl"
                            :alt="courseName"
                            :full-height="true"
                        ></component-image>
                    </template>
                    <template v-else>
                        <v-icon name="image"/>
                    </template>
                </div>
            </div>
            <div class="column">
                <div class="dashboard__list_enrolments_grid_item_content">
                    <h2 class="dashboard__list_enrolments_grid_item_content_title">{{courseName}}</h2>
                    <div class="dashboard__list_enrolments_grid_item_content_details">
                        <component-text
                            v-if="courseEnrolmentDate"
                            :size="'small'"
                        >Enrolled {{ courseEnrolmentDate }}</component-text>
                        <component-text
                            v-if="courseCompletedDate"
                            :size="'small'"
                        >Completed {{ courseCompletedDate }}</component-text>
                    </div>
                    <div :class="['dashboard__list_enrolments_grid_item_content_status']">
                        <component-status :status="courseEnrolmentStatus"/>
                    </div>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import api from '@/api'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentImage from '@/components/default/shared/ComponentImage'
import { fromUTCDateTimeToLocalISOCustom, toLocaleDateTime } from '@/functions'
import { User } from '@/User'
import ComponentText from '@/components/default/shared/ComponentText'

export default {
  components: { ComponentText, ComponentImage, ComponentStatus },
  name: 'dashboard-list-enrolments-grid-item',
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    courseThumbnailUrl () {
      if (this.item.courseImage) {
        return `${api.files}/file/${this.item.courseImage}`
      }
      return false
    },
    courseId () {
      return this.item.courseId
    },
    courseCatalogId () {
      return this.item.catalogItemId
    },
    courseVersionId () {
      return this.item.courseVersionId
    },
    courseName () {
      return this.item.courseName
    },
    courseEnrolmentStatus () {
      return this.item.enrolmentStatus
    },
    courseEnrolmentDate () {
      return toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.enrolmentDate || this.item.enrolmentDateTime))
    },
    courseCompletedDate () {
      return toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.completedAt))
    },
    courseWorkspaceId () {
      return this.item.workspaceId
    },
    currentWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    }
  },
  methods: {
    handleSwitchWorkspaceRedirect (to) {
      const currentWorkspaceId = this.currentWorkspaceId
      const courseWorkspaceId = this.courseWorkspaceId

      if (currentWorkspaceId !== courseWorkspaceId) {
        this.$store.dispatch('authUserLoginSSOWorkspace', courseWorkspaceId).then(() => {
          this.$store.dispatch('defaultNotificationToastsAdd', {
            title: 'Session redirect',
            message: `Your workspace has been switched.`,
            status: 'success'
          })
          this.$router.push(to)
        }).catch(() => {
          this.$store.dispatch('defaultNotificationToastsAdd', {
            title: 'Session redirect',
            message: `You can't be redirected to the course due to issues with switching workspace.`,
            status: 'error'
          })
        })
      } else {
        this.$router.push(to)
      }
    },
    handleRedirectToCourse () {
      if (this.name === 'dashboard-list-completions-courses') {
        this.handleSwitchWorkspaceRedirect({ name: 'ebs-course-enrolment-show', params: { courseId: this.courseId, versionId: this.courseVersionId, courseCatalogId: this.courseCatalogId, enrolmentId: this.courseEnrolmentId } })
      } else {
        this.handleSwitchWorkspaceRedirect({ name: 'ebs-course-version-show', params: { courseId: this.courseId, versionId: this.courseVersionId, courseCatalogId: this.courseCatalogId } })
      }
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/dashboard/list/dashboardlistgriditem";
</style>
